import { render, staticRenderFns } from "./MediaZoomDialog.vue?vue&type=template&id=2323be03"
import script from "./MediaZoomDialog.vue?vue&type=script&lang=ts"
export * from "./MediaZoomDialog.vue?vue&type=script&lang=ts"
import style0 from "./MediaZoomDialog.vue?vue&type=style&index=0&id=2323be03&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports